module.exports = __webpack_public_path__ + "img/welcome.12f3ed67.svg";